<template>
  <div class="access-list-sidebar px-6 py-4">
    <v-btn
      color="primary"
      variant="flat"
      size="small"
      class="mb-4"
      @click="setModal({ field: 'grantAccess', value: true })"
    >
      Grant Access
    </v-btn>

    <div
      v-for="entry in sortedList"
      :key="entry.ulid"
      class="access-list-item d-flex align-center py-3 border-b-sm"
      @mouseenter="hoveredUlid = entry.ulid"
      @mouseleave="hoveredUlid = null"
    >
      <div class="d-flex flex-column flex-grow-1">
        <span class="text-body-2 text-textDarkest">{{ entry.name }}</span>
        <span class="text-caption text-textLight">since {{ formatDisplayDate(entry.created_at) }}</span>
      </div>

      <v-btn
        v-if="!readOnly && hoveredUlid === entry.ulid"
        icon
        size="x-small"
        variant="text"
        color="error"
        @click="openRevokeModal(entry)"
      >
        <v-icon icon="mdi-close" />
      </v-btn>
    </div>

    <GrantAccessModal />
    <RevokeAccessModal />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useModals } from '@/stores/modals/modals';
import { formatDisplayDate } from '@/helpers/date';
import GrantAccessModal from '@/components/document/rightPanel/GrantAccessModal.vue';
import RevokeAccessModal from '@/components/document/rightPanel/RevokeAccessModal.vue';

const { jobProfile, readOnly } = storeToRefs(useCurrentJobProfile());
const { setModal } = useModals();

const hoveredUlid = ref(null);

const accessList = computed(() => jobProfile.value?.access_list ?? []);

const sortedList = computed(() => [...accessList.value].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')));

const openRevokeModal = (entry) => {
  setModal({ field: 'revokeAccess', value: true, params: { ulid: entry.ulid, name: entry.name } });
};
</script>
